import BaseList from './BaseList'

class All extends BaseList {
  filterActivity = () => true
}

export default All